module.exports = __webpack_public_path__ + "img/组 37@2x.a3806f90.png";